export const defaultForms = {
  login: {
    form: {
      formCode: 'login',
      formTitle: 'Login',
      requireSession: false,
    },
    relatedFunctions: [],
    requiredFunctions: [],
    states: [],
    transitions: [],
    sections: [
      {
        sectionCode: 'userInformation',
        sectionTitle: 'userInformation',
        visibleStates: [],
        subsections: [
          {
            subsectionCode: 'default',
            subsectionTitle: 'default',
            visibleStates: [],
            elements: [
              {
                elementTypeName: 'FIELD',
                elementCode: 'userLogin',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'userPassword',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'sessionCode',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'sessionHandler',
              },
              {
                elementTypeName: 'ACTION',
                elementCode: 'openSession',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'sessionPublicData',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'externalAuthData',
              },
              {
                elementTypeName: 'ACTION',
                elementCode: 'forgotPassword',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'correspondentId',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'deviceId',
              },
              {
                elementTypeName: 'ACTION',
                elementCode: 'getUserId',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'questions',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'questionList',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'questionOne',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'responseOne',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'questionTwo',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'responseTwo',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'questionThree',
              },
              {
                elementTypeName: 'FIELD',
                elementCode: 'responseThree',
              },
              {
                elementTypeName: 'ACTION',
                elementCode: 'saveQuestions',
              },
            ],
          },
        ],
      },
    ],
    fields: [
      {
        fieldCode: 'userLogin',
        fieldTitle: 'Código de usuario',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: true,
        editable: true,
        required: true,
        serverAction: false,
        restricted: false,
        visibleStates: ['CREATE'],
        editableStates: ['EDIT', 'VIEW', 'ACCESS'],
        alignment: 'LEFT',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
      {
        fieldCode: 'userPassword',
        fieldTitle: 'Contraseña',
        fieldTypeCode: 'TEXT',
        captureType: 'PASSWORD',
        visible: true,
        editable: true,
        required: true,
        serverAction: false,
        restricted: false,
        visibleStates: ['CREATE', 'ACCESS'],
        editableStates: ['EDIT', 'VIEW'],
        alignment: 'LEFT',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
      {
        fieldCode: 'sessionCode',
        fieldTitle: 'sessionCode',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: false,
        editable: false,
        required: false,
        serverAction: false,
        restricted: false,
        visibleStates: ['CREATE'],
        editableStates: ['EDIT', 'VIEW'],
        alignment: 'LEFT',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
      {
        fieldCode: 'sessionHandler',
        fieldTitle: 'sessionHandler',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: false,
        editable: false,
        required: false,
        serverAction: false,
        restricted: false,
        visibleStates: ['CREATE'],
        editableStates: ['EDIT', 'VIEW'],
        alignment: 'LEFT',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
      {
        fieldCode: 'sessionPublicData',
        fieldTitle: 'sessionPublicData',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: false,
        editable: false,
        required: false,
        serverAction: false,
        restricted: false,
        visibleStates: ['CREATE'],
        editableStates: ['EDIT', 'VIEW'],
        alignment: 'LEFT',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
      {
        fieldCode: 'externalAuthData',
        fieldTitle: 'externalAuthData',
        fieldTypeCode: 'OBJECT',
        captureType: 'INPUT',
        visible: false,
        editable: false,
        required: false,
        serverAction: false,
        restricted: false,
        fieldOptions: [],
        visibleStates: [],
        editableStates: [],
        alignment: 'LEFT',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
      {
        fieldCode: 'correspondentId',
        fieldTitle: 'correspondentId',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: false,
        editable: false,
        required: false,
        serverAction: false,
        restricted: false,
        fieldOptions: [],
        visibleStates: [],
        editableStates: [],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
      {
        fieldCode: 'deviceId',
        fieldTitle: 'deviceId',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: false,
        editable: false,
        required: false,
        serverAction: false,
        restricted: false,
        fieldOptions: [],
        visibleStates: [],
        editableStates: [],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
      {
        fieldCode: 'questions',
        fieldTitle: 'Preguntas',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: false,
        editable: false,
        required: false,
        serverAction: false,
        restricted: false,
        visibleStates: ['CREATE'],
        editableStates: ['EDIT', 'VIEW', 'ACCESS'],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
      {
        fieldCode: 'questionOne',
        fieldTitle: 'Primera pregunta de seguridad',
        fieldTypeCode: 'TEXT',
        captureType: 'LIST',
        visible: false,
        editable: true,
        required: false,
        serverAction: true,
        restricted: false,
        visibleStates: ['CREATE'],
        editableStates: ['EDIT', 'VIEW', 'ACCESS'],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
      {
        fieldCode: 'questionTwo',
        fieldTitle: 'Segunda pregunta de seguridad',
        fieldTypeCode: 'TEXT',
        captureType: 'LIST',
        visible: false,
        editable: true,
        required: false,
        serverAction: true,
        restricted: false,
        visibleStates: ['CREATE'],
        editableStates: ['EDIT', 'VIEW', 'ACCESS'],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
      {
        fieldCode: 'questionThree',
        fieldTitle: 'Tercera pregunta de seguridad',
        fieldTypeCode: 'TEXT',
        captureType: 'LIST',
        visible: false,
        editable: true,
        required: false,
        serverAction: true,
        restricted: false,
        visibleStates: ['CREATE'],
        editableStates: ['EDIT', 'VIEW', 'ACCESS'],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
      {
        fieldCode: 'responseOne',
        fieldTitle: 'Respuesta',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: true,
        editable: true,
        required: true,
        serverAction: false,
        restricted: false,
        visibleStates: ['CREATE'],
        editableStates: ['EDIT', 'VIEW', 'ACCESS'],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
      {
        fieldCode: 'responseTwo',
        fieldTitle: 'Respuesta',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: true,
        editable: true,
        required: true,
        serverAction: false,
        restricted: false,
        visibleStates: ['CREATE'],
        editableStates: ['EDIT', 'VIEW', 'ACCESS'],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
      {
        fieldCode: 'responseThree',
        fieldTitle: 'Respuesta',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: true,
        editable: true,
        required: true,
        serverAction: false,
        restricted: false,
        visibleStates: ['CREATE'],
        editableStates: ['EDIT', 'VIEW', 'ACCESS'],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
      {
        fieldCode: 'questionList',
        fieldTitle: 'questionList',
        fieldTypeCode: 'TEXT',
        captureType: 'INPUT',
        visible: false,
        editable: false,
        required: false,
        serverAction: false,
        restricted: false,
        visibleStates: ['CREATE'],
        editableStates: ['EDIT', 'VIEW', 'ACCESS'],
        alignment: 'LEFT',
        format: '',
        defaultValue: '',
        tooltip: '',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
    ],
    actions: [
      {
        actionCode: 'openSession',
        actionTitle: 'Ingresar',
        visible: true,
        serverAction: true,
        visibleStates: ['ACCESS'],
        enabledStates: ['EDIT'],
        position: 'BODY',
        fieldRestrictedCode: null,
        operatorRestricted: null,
        valueRestricted: null,
        iconName: 'LOGIN',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
        customAttributes: {
          class: 'row-button',
          expand: 'block',
        },
      },
      {
        actionCode: 'forgotPassword',
        actionTitle: 'Recuperar Contraseña',
        visible: true,
        serverAction: true,
        visibleStates: ['ACCESS'],
        enabledStates: [],
        position: 'BODY',
        fieldRestrictedCode: null,
        operatorRestricted: null,
        valueRestricted: null,
        iconName: 'CANCEL',
        newState: '',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
      {
        actionCode: 'getUserId',
        actionTitle: 'Ingresar',
        visible: true,
        serverAction: true,
        visibleStates: [],
        position: 'BODY',
        fieldRestrictedCode: null,
        operatorRestricted: null,
        valueRestricted: null,
        iconName: 'CANCEL',
        newState: '',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
      {
        actionCode: 'saveQuestions',
        actionTitle: 'Guardar',
        visible: false,
        serverAction: true,
        visibleStates: ['SECURITY_QUESTION'],
        position: 'BODY',
        fieldRestrictedCode: null,
        operatorRestricted: null,
        valueRestricted: null,
        iconName: 'SEND',
        newState: '',
        sectionCode: 'userInformation',
        subsectionCode: 'default',
      },
    ],
    tables: [],
  },
};
